import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IQueryParamDrivenDrawerContentProvider } from '../../components/query-param-driver-drawer/IQueryParamDrivenDrawerContentProvider';
import { QueryParamDrivenDrawerHelper } from '../../components/query-param-driver-drawer/QueryParamDrivenDrawerHelper';
import { StructuredRecordEditorDrawer } from '../structured-records/StructuredRecordEditorDrawer';
import { MedicationDescriptor } from './MedicationDescriptor';
import { MedicationFormState } from './MedicationFormState';

interface IMedicationEditorDrawerProps {
    id: string;
}

export class MedicationEditorDrawer implements IQueryParamDrivenDrawerContentProvider<IMedicationEditorDrawerProps> {
    static inject = () => [QueryParamDrivenDrawerHelper];
    constructor(private drawerHelper: QueryParamDrivenDrawerHelper<IMedicationEditorDrawerProps>){}

    mode = 'edit-medication';

    Component = MedicationEditorDrawerView;

    open = (props: IMedicationEditorDrawerProps) => {
        this.drawerHelper.open({ mode: this.mode, ...props });
    };

    buildQueryParams = (props: IMedicationEditorDrawerProps) => {
        return this.drawerHelper.buildQueryParams({ mode: this.mode, id: props.id });
    };
}

const MedicationEditorDrawerView: React.FC<IMedicationEditorDrawerProps> = ({ id }) => {
    const descriptor = useInstance(MedicationDescriptor);
    const formState = useInstance(MedicationFormState);

    return (
        <StructuredRecordEditorDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
